<template>
  <!-- 领用申请单列表 -->
  <div class="form">
    <div class="container">
      <!-- 搜索表单 -->
      <el-form :model="searchForm" label-width="130px">
        <el-row>
          <el-col span="6">
            <el-form-item label="领用申请单号：" prop="requisitionNo">
              <el-input
                placeholder="领用申请单号"
                maxlength="50"
                show-word-limit
                clearable
                v-model="searchForm.requisitionNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="单据日期：" prop="requisitionRq">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.requisitionRq"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="单据日期"
                size="small"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="申请人：" prop="requisitionUserName">
              <el-input
                placeholder="申请人"
                maxlength="30"
                show-word-limit
                clearable
                v-model="searchForm.requisitionUserName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item>
              <div style="float: right;">
                <el-button type="primary" icon="el-icon-search" size="small" @click="searchChange"
                  >搜索</el-button
                >
                <el-button plain icon="el-icon-delete" size="small" @click="searchReset"
                  >清空</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :page.sync="tablePage"
        @on-load="loadData"
        @row-click="rowClick"
      >
        <template slot="radio" slot-scope="{ row }">
          <el-radio v-model="selectRowIndex" :label="row.$index">{{ '' }}</el-radio>
        </template>
      </avue-crud>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">确定</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getUseOrderListApi } from '@/api/warehouse/out';

export default {
  name: 'UseOrderList',
  props: {
    // 项目id
    projectId: {
      type: String,
      default: '',
    },
    // 仓库id
    warehouseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 搜索表单
      searchForm: {},
      // 选中的行在当前页的序号
      selectRowIndex: -1,
      // 表格数据
      tableData: [],
      // 选中的项
      selectedList: [],
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '选择',
            prop: 'radio',
            width: 50,
            slot: true,
          },
          {
            label: '领用申请单号',
            prop: 'requisitionNo',
          },
          {
            label: '物料摘要',
            prop: 'materialSummary',
          },
          {
            label: '仓库名称',
            prop: 'warehouseName',
          },
          {
            label: '领用部门',
            prop: 'deptName',
          },
          {
            label: '申请人',
            prop: 'requisitionUserName',
          },
          {
            label: '单据时间',
            prop: 'requisitionTime',
          },
          {
            label: '状态',
            prop: 'requisitionStatus',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=warehouse_requisition_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
        ],
      },
    };
  },
  methods: {
    /* 加载列表数据 */
    loadData(page) {
      page = page || this.tablePage;
      getUseOrderListApi(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            projectId: this.projectId,
            warehouseId: this.warehouseId,
          },
          this.searchForm
        )
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        if (this.selectRowIndex >= this.tablePage.total) {
          this.selectRowIndex = -1;
        }
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.selectRowIndex = -1;
      this.searchForm = {};
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange() {
      this.selectRowIndex = -1;
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 行点击 */
    rowClick(row) {
      this.selectRowIndex = row.$index;
    },
    doSave() {
      if (this.selectRowIndex < 0) {
        this.$message.error('请先选择数据');
        return;
      }
      this.$emit('update', this.tableData[this.selectRowIndex]);
      this.doClose();
    },
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../dialog-form.scss';

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
